import React from 'react';
import { useRouter } from 'next/router';
import { Modules, P165ArticleListPage as P165ArticleListPageType } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import { ModuleHeader } from '~/templates/blocks/components/ModuleHeader';
import { ArticlesMenu } from './components/ArticleMenuSlider';
import { Articles } from './components/Articles';
import { ArticleListSchema } from '~/features/articleList/components/ArticleListSchema';
import PageHero from '../PageHero/PageHero';

type P165ArticleListPageProps = P165ArticleListPageType;

export const P165ArticleListPage = (props: P165ArticleListPageProps) => {
    const { query } = useRouter();

    const { heroTheme, heroImage, heroHeader, heroImageAltText } = props;
    const page = (query.page as string) ? parseInt(query.page as string) : 1;
    const slice = 8;

    return (
        <>
            <ArticleListSchema articles={props.articles.slice(0, slice)} />

            <PageHero
                image={heroImage}
                imageAltText={heroImageAltText}
                theme={heroTheme}
                headline={heroHeader}
            >
                <ArticlesMenu categories={props.categories} />
            </PageHero>

            <DynamicBlockList elements={props.pageElements as Modules[]} />

            {props.middlePageElements?.length > 0 && (
                <>
                    {props.articles?.length > 0 && (
                        <ArticlesList
                            {...props}
                            articles={props.articles.slice(0, slice)}
                            priorityCount={4}
                        />
                    )}
                    <DynamicBlockList
                        isSkipShown
                        elements={props.middlePageElements as Modules[]}
                    />
                    {props.articles?.length > slice && (
                        <ArticlesList
                            page={page}
                            {...props}
                            articles={props.articles.slice(slice)}
                        />
                    )}
                </>
            )}
            {!props.middlePageElements?.length && (
                <ArticlesList page={page} {...props} articles={props.articles} priorityCount={4} />
            )}
            <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
        </>
    );
};

const ArticlesList = (
    props: P165ArticleListPageProps & { page?: number; priorityCount?: number },
) => {
    return (
        <ModuleContainer {...props} spacingTop="small" spacingBottom="small">
            <ModuleHeader
                noGutter
                headline={props.headline}
                subHeadline={props.subHeadline}
                link={props.callToAction}
            />

            <Articles
                page={props.page}
                articles={props.articles}
                priorityCount={props.priorityCount}
            />
        </ModuleContainer>
    );
};
